import { render, staticRenderFns } from "./ContractDetailsLeftSidebar.vue?vue&type=template&id=0a8cc1aa"
import script from "./ContractDetailsLeftSidebar.vue?vue&type=script&lang=js"
export * from "./ContractDetailsLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports